<div class="container u-pb60">
    <div class="row mobile u-pt30">
        <div class="col-md-12">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a [routerLink]="['/']" style="color: black;"> {{'verification.home' | translate}} </a> &nbsp;</li>
                    <li class="breadcrumb-item active" aria-current="page" style="color: black;"> - </li><span style="color: black;"> {{'verification.third-verification' | translate}}</span>
                </ol>
            </nav>
            <h2 class="o-title">{{'verification.authorized' | translate}}</h2>
            <p class="o-text">{{'verification.details-authorized' | translate}}</p>
        </div>

        <div class="col-md-12">
            <label class="o-title o-title--label o-title--required">{{'verification.name-info' | translate}}</label>
            <div class="col-md-4" style="padding-left: 0px">
                <input type="text" class="o-form__select" matInput [matAutocomplete]="autoPersonBHP" (input)="searchPerson($event)" [(ngModel)]="searchPeople" placeholder="{{'verification.searchpeople' | translate}}">
                <mat-autocomplete #autoPersonBHP="matAutocomplete">
                    <mat-option *ngFor="let option of peoples" [value]="option.firstName +' '+ option.lastName">
                        <div *ngIf="personFound" (click)="addpeopleMdmidFilterValue(option)">
                            <span mat-raised-button aria-label="Button that displays a tooltip in various positions">
                          {{option.firstName}} {{option.lastName}} {{option.passportNumber && option.passportNationality ? ' - ' + option.passportNumber + ' - ' + searchCountry(option.passportNationality) : '' }} 
                          </span> <br>
                            <small style="color: #E65400">{{option.email}}</small>

                        </div>
                    </mat-option>
                </mat-autocomplete>
            </div>
            <div class="col-md-4">
                <button [attr.disabled]="!person.email ? true: null" class="btn btn--primary" style="font-size: 16px;line-height: 23px;width: 40%;" [routerLink]="['/external-accesses/', emailDocument]">{{'verification.search' | translate}}</button>
            </div>
        </div>



    </div>